import { render, staticRenderFns } from "./dailyTrainingDetail.vue?vue&type=template&id=2765368d&scoped=true&"
import script from "./dailyTrainingDetail.vue?vue&type=script&lang=js&"
export * from "./dailyTrainingDetail.vue?vue&type=script&lang=js&"
import style0 from "./dailyTrainingDetail.vue?vue&type=style&index=0&id=2765368d&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2765368d",
  null
  
)

export default component.exports